import { useState, memo, useCallback } from 'react';

import StageButton from '../StageButton';
import ShipperDialog from './ShipperDialog';
import { StyledTableCell } from 'Utils';
import { sendRequest, REQUEST_ACTIONS } from 'utils/Communicator';
import { useDispatch, useSelector } from 'react-redux';
import { snackbarToggle } from 'reducers/snackbarSlicer';

const Shipper = ({ loginUser, order, pageName }) => {
    const dispatch = useDispatch();
    const getStatus = () => {
        var stage = order.orderStage ? order.orderStage[1] : null;
        if (order.location?.id != 2) {
            if (order.incoterms?.id == 1 || order.incoterms?.id == 2 || order.incoterms?.id == 3 || order.incoterms?.id == 4 || order.incoterms?.id == 5 || order.incoterms?.id == 6) {
                stage = {};
                stage.status = "dissable";
                stage.notes = "";
            }
        }
        return stage;
    }
    const currentStage = order.orderStage ? order.orderStage[1] : null;
    const failedCallback = useCallback(
        m => dispatch(snackbarToggle({ type: 'error', m })),
        [dispatch],
    );
    const [openDialog, setOpenDialog] = useState(false);
    const [order1, setOrder1] = useState(false);
    const onHandleOpenDialog = () => {
        sendRequest('/api/order/' + order.id, REQUEST_ACTIONS.GET, '', {
            successCallback: response => {
                var res = JSON.parse(JSON.stringify(response));
                setOrder1(res);
                setOpenDialog(true);
            },
            failedCallback,
        });
    }

    return (
        <StyledTableCell style={{ width: "5vw", p: 0 }}>
            <StageButton stage={getStatus()} onHandleOpenDialog={onHandleOpenDialog} stageName='Shipper' loginUser={loginUser} />
            {openDialog && <ShipperDialog pageName={pageName} loginUser={loginUser} order={order1} openDialog={openDialog} setOpenDialog={setOpenDialog} />}
        </StyledTableCell>
    );
};

export default memo(Shipper);
